// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3c88714f","977":"6cc08edc"}[chunkId] + ".chunk.js";
};